import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06711a38"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("iframe", {
    class: "google-map",
    src: _ctx.srcUrl,
    style: {"border":"0"},
    allowfullscreen: "",
    loading: "lazy",
    width: _ctx.width,
    height: _ctx.height
  }, null, 8, _hoisted_1))
}